import log from 'loglevel';

export default {
  getters: {
    navigationSteps(state, getters, rootState) {
      const modelSteps = [];
      const models = rootState.recipe.models || [];
      for (const m of models) {
        modelSteps.push({
          key: `models/${m.name}`,
          label: m.name,
        });
      }
      return [
        { key: 'project', label: 'Project Details' },
        { key: 'auth', label: 'Authentication' },
        {
          key: 'models',
          label: 'Database Models',
          steps: modelSteps,
        },
        { key: 'api', label: 'API' },
        { key: 'devops', label: 'DevOps' },
        { key: 'generate', label: 'Finish & Download' },
      ];
    },

    fieldTypeChoices (state, getters, rootState) {
      const r = rootState.recipe;
      const choices = [
        { value: 'string', text: 'String' },
        { value: 'integer', text: 'Integer' },
        { value: 'number', text: 'Number' },
        { value: 'email', text: 'E-mail' },
        { value: 'url', text: 'URL' },
        { value: 'date', text: 'Date/Time' },
        { value: 'boolean', text: 'Boolean' },
        { value: 'fk', text: 'Foreign Key' },
        { value: 'm2m', text: 'Many to Many' },
      ];

      if (r.orm === 'mongoose' || r.db_provider != 'sqlite') {
        choices.push({ value: 'json', text: 'JSON' });
      }

      return choices;
    },

    dbSupportsStringLength(state, getters, rootState) {
      const r = rootState.recipe;
      return r.orm === 'mongoose' || r.db_provider != 'sqlite';
    },

    relationTargets(state, getters, rootState) {
      return rootState.recipe.models;
    },

    activeRelations(state, getters, rootState) {
      const targets = [];
      for (const m of rootState.recipe.models) {
        for (const f of m.fields) {
          if (f.target) {
            targets.push({
              source: m.name,
              target: f.target,
            });
          }
        }
      }
      return targets;
    },
  },
  mutations: {
    setModel(state, { originalName, ...model }) {
      const r = this.state.recipe;
      const models = r.models ? [...r.models] : [];

      if (originalName) {
        for (let i = 0; i < models.length; i += 1) {
          if (models[i].name === originalName) {
            log.debug(`updateModel(): updating existing model ${model.name}`);
            models[i] = model;
            this.commit('updateRecipe', { models });
          }

          for (const f of models[i].fields) {
            if (originalName && f.target === originalName) {
              log.debug(`updateModel(): updating relation ${models[i].name}.${f.name} from old name ${originalName} to new name ${model.name}`);
              f.target = model.name;
            }
          }
        }

        if (
          originalName &&
          originalName !== model.name &&
          this.state.currentStep === `models/${originalName}`
        ) {
          this.commit('navigate', `models/${model.name}`);
        }
        return;
      }

      log.debug(`updateModel(): adding new model ${model.name}`);
      models.push(model);
      this.commit('updateRecipe', { models });

      if (!this.state.recipe.models) this.state.recipe.models = models;
    },
  },
};
